const CustomerFeedback = () => {
    return (
        <section className="same_space pt-0">
            <div className="container">
                <div className="customer_hedding">
                    <h2>Customer Feedback</h2>
                    <p>What Our Customers Have To Say</p>
                </div>
                <div className="row">
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div className="customer_box">
                            <img src="images/customer-logo.svg" alt="" />
                            <p>We had AC installed early summer of 2020 and had everything up in running same day. Everyone
                                was very friendly and in no rush to quickly get out the door, which I appreciated. Literally
                                any problem we've had since (typical maintenance issues in an older home) have been fixed
                                and response time has been super fast. Everyone I've worked with so far has been great,
                                knowledgeable and never trying to upsell anything</p>
                            <h3>Jenna F</h3>
                            <img src="images/star.svg" alt="" className="mb-0" />
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div className="customer_box">
                            <img src="images/customer-logo.svg" alt="" />
                            <p>have used Sparks heating on many occasions. I have referred them to my real. estate clients
                                and have used their services personally in my own home. They are professional, honest and
                                have the best prices I have seen. I also appreciate the fact that they are very responsive.
                                I would highly recommend Sparks heating to anyone looking for HVAC service. <br /> You will
                                not
                                regret it.</p>
                            <h3>Rexanne S</h3>
                            <img src="images/star.svg" alt="" className="mb-0" />
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div className="customer_box">
                            <img src="images/customer-logo.svg" alt="" />
                            <p>I can not say enough great things about Sparks heating and Air. They are honest, trustworthy,
                                and they do a good job. Their product and services are very affordable. You will not be
                                disappointed. I work in real estate and have availed their services and expertise several
                                times, including referring them to my clients. So far I have not had one complaint. I trust
                                them completely and you won't be disappointed.</p>
                            <h3>Tracy P</h3>
                            <img src="images/star.svg" alt="" className="mb-0" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CustomerFeedback;